module.exports = __webpack_public_path__ + "img/MES8Indice2.44040b17.png";